module.exports = __webpack_public_path__ + "media/images/team/armie-bravo-492f560600b43fa13db11e2ed75a1002.png";